import { render, staticRenderFns } from "./ExternalLinkIcon.vue?vue&type=template&id=d303c4aa&functional=true"
import script from "./ExternalLinkIcon.vue?vue&type=script&lang=js"
export * from "./ExternalLinkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports